import { Script, Env } from '@didi/utils'

const SDK_URL = '//static.udache.com/agility-sdk/1.0.4/bridge.js'

let cbs = []
let loaded = false
export function initDidiSDK(sdkUrl) {
  if (!Env.isPassenger) {
    return
  }
  loadidiSDK(sdkUrl).then(() => {
    loaded = true
    next(null)
  }).catch((e) => {
    next(e)
  })

  function next(err) {
    cbs.forEach((cb) => {
      cb(err, window.D.bridge)
    })
  }
}

initDidiSDK(SDK_URL)

export function didiSDKReady(callback) {
  if (loaded) {
    callback(null, window.D.bridge)
  } else {
    cbs.push(callback)
  }
}

export function loadidiSDK(sdkUrl) {
  if (window.D && window.D.bridge) {
    return Promise.resolve()
  } else {
    return Script.loadScript(sdkUrl)
  }
}
